/**
 * file : MyPage/Info.jsx
 * 설명 : 상단 접속자 정보
 */

import { Fnc } from "common/globals";
import { useSelector } from 'react-redux';
import logo from "assets/images/profile_img.jpg";

export default function Info() {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  return(
    <div className="my_page_intor">
      <div className="total_money"><span className="won font_style1"></span>{info.settlement_amount.toLocaleString()}</div>
      <h2 className="font_style1">{info.userid}</h2>
      <p className="font_style1">date {Fnc.FormatDate(info.created_at)}</p>
      <div className="profile_img">
        <img src={logo} alt="logo" />
      </div>
    </div>
  )
}